import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ComponentFormulas} from "../../models/component-formulas";
import Helpers from "../../utils/helpers";

@Injectable()
export class ComponentFormulaControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getById(id: string): Observable<ComponentFormulas> {
    return this.http.get(this.baseUrl + "componentformulas/" + id) as Observable<ComponentFormulas>;
  }

  public save(id: string, componentFormula: ComponentFormulas): Observable<ComponentFormulas> {
    Helpers.trimRecursiveObj(componentFormula);
    const body = JSON.stringify(componentFormula);
    return this.http.put(this.baseUrl + "componentformulas/" + id, body) as Observable<ComponentFormulas>;
  }

  public getComponentFormula(serviceId: string, key: string): Observable<ComponentFormulas> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/componentformulas/" + key) as Observable<ComponentFormulas>;
  }

  public saveComponentFormula(serviceId: string, key: string, componentFormula: ComponentFormulas): Observable<ComponentFormulas> {
    Helpers.trimRecursiveObj(componentFormula);
    const body = JSON.stringify(componentFormula);
    return this.http.put(this.baseUrl + "service/" + serviceId + "/componentformulas/" + key, body) as Observable<ComponentFormulas>;
  }
}
